import { render, staticRenderFns } from "./blqApp.vue?vue&type=template&id=d053ec90&scoped=true&"
import script from "./blqApp.vue?vue&type=script&lang=js&"
export * from "./blqApp.vue?vue&type=script&lang=js&"
import style0 from "./blqApp.vue?vue&type=style&index=0&id=d053ec90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d053ec90",
  null
  
)

export default component.exports